// ======================================================================
// File Name       : ChildUserContainer.js
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Modal, Button } from 'react-bootstrap';
import { getUserRelationList } from '../../actions/UserAction';
import ChildUserSearch from '../../components/user/ChildUserSearch';
import ChildUserList from '../../components/user/ChildUserList';
import { USER_TYPE } from '../../constants/UserConstants';
import * as Constant from '../../constants/index';
import MessageSearch from '../../components/MessageSearch';

class ChildUserContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loginId: '',
      userName: '',
      showModal: false,
      userRelations: [],
      recordNum: 0,
      returnMaxNum: Constant.RETURN_MAX_NUM,
      isAllowShowSearchMessage: false,
      isInit: false,
    };
    this.selectedList = [];
    this.onHandleChange = this.onHandleChange.bind(this);
    this.onSearchData = this.onSearchData.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.onHandleChecked = this.onHandleChecked.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  /**
   * componentDidMount event executed after first render
   */
  componentDidMount() {
    this.onSearchData();
  }

  componentWillReceiveProps(nextProps) {
    const { user, childUserList } = nextProps;
    const { userRelationInfo } = user;
    this.selectedList = childUserList.slice();
    const { recordNum, userList } = userRelationInfo;
    let userRelations = [];
    if (userList) {
      userRelations = JSON.parse(JSON.stringify(userList));
      for (const childUser of this.selectedList) {
        for (const userRelation of userRelations) {
          if (childUser.userSecernId === userRelation.userSecernId) {
            userRelation.isChecked = childUser.userSecernId === userRelation.userSecernId;
          }
        }
      }
    }
    this.setState({
      userRelations,
      recordNum,
    });
  }

  /**
   * Get user list
   *
   */
  onSearchData() {
    this.setState({
      startPosition: 0,
      isAllowShowSearchMessage: false,
      isInit: false,
    }, () => {
      this.getUserRelations();
    });
  }

  getUserRelations() {
    const { dispatch } = this.props;
    const param = {
      selectTargetData: Constant.SELECT_TARGET_DATA.DATA,
      searchInfo: {
        userType: USER_TYPE.STUDENT,
        userName: this.state.userName,
        loginId: this.state.loginId,
        startPosition: this.state.startPosition,
        returnMaxNum: this.state.returnMaxNum,
      },
    };
    dispatch(getUserRelationList(param)).then(() => {
      if (!this.state.isInit) {
        this.setState({ isAllowShowSearchMessage: true });
      }
    });
  }

  /**
   * Handle event when user change page on paging
   * @param page
   */
  getStartEndData(startPosition) {
    this.setState(
      {
        startPosition,
      },
      this.getUserRelations,
    );
  }

  /**
   * Handle event when click on OK of  dialog
   */
  onOk() {
    this.props.onOK(this.selectedList);
  }

  /**
   * Handle event when click on cancel of  dialog
   */
  onCancel() {
    this.selectedList = [];
    this.props.onCancel();
  }

  /**
 * Handle change input field
 *
 * @param {*} event
 */
  onHandleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  onHandleChecked(id, event) {
    const { userRelations } = this.state;
    for (const user of userRelations) {
      if (user.userSecernId && user.userSecernId === id) {
        user.isChecked = user.isChecked ? !user.isChecked : true;
        user.isNewChecked = true;
        if (user.isChecked) {
          this.selectedList.push(user);
        } else {
          for (let i = 0; i < this.selectedList.length; i++) {
            if (this.selectedList[i].userSecernId === id) {
              this.selectedList.splice(i, 1);
            }
          }
        }
      }
    }
    this.setState({ userRelations });
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  render() {
    const style = {
      background: 'none',
      width: 'auto',
      marginLeft: 0,
      left: 0,
    };
    const { userRelations, recordNum } = this.state;
    return (
      <Modal
        className="modal-container"
        show={this.props.showModal}
        onHide={this.onCancel}
        size={Constant.MODAL_SIZE.lg}
        style={style}
      >
        <Modal.Header onHide={this.onCancel} closeButton>
          <Modal.Title className="text-center">
            対象を選択してください
          </Modal.Title>
        </Modal.Header>
        <Modal.Body />
        <Col sm={12}>
          <MessageSearch
            recordNum={recordNum}
            resultList={userRelations}
            isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
            dismissMessage={this.dismissMessage}
          />
        </Col>
        <ChildUserSearch
          startPosition={this.state.startPosition}
          recordNum={recordNum}
          onHandleChange={this.onHandleChange}
          onSearchData={this.onSearchData}
          getStartEndData={this.getStartEndData}
        />
        <ChildUserList userRelations={userRelations} onHandleChecked={this.onHandleChecked} />
        <Modal.Footer>
          <Col sm={12} className="text-center">
            <Button
              className="btn-96 margin-10"
              onClick={this.onCancel.bind(this)}
            >
              キャンセル
            </Button>
            <Button variant="primary" className="btn-96 margin-10" onClick={this.onOk.bind(this)}>
              OK
            </Button>
          </Col>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...{ user: state.user },
});

export default connect(mapStateToProps)(ChildUserContainer);
